import * as operations from '../../../state/projects/operations';

import DragAndDrop from '../../views/DragAndDrop';
import { connect } from 'react-redux';

const mapStateToProps = state => ({});

const mapDispatchToProps = (dispatch, ownProps) => ({
  assignProject: (projectId, engagementId) =>
    dispatch(operations.assignProject(projectId, engagementId))
});

const DragAndDropComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(DragAndDrop);

export default DragAndDropComponent;



// WEBPACK FOOTER //
// ./src/components/container/DragAndDrop/index.js